import React from 'react';
import { IVisitorQuestionProps } from './types';
import { ToggleButtonGroup } from '../../../form';
import { Alert } from 'react-bootstrap';
import styles from './VisitorQuestion.module.css';

const VisitorQuestion: React.FC<IVisitorQuestionProps> = ({
  answer,
  noMessage,
  yesMessage,
  children,
  onAnswer,
}) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>{children}</p>
      <ToggleButtonGroup activeKey={answer} onChange={onAnswer}>
        <ToggleButtonGroup.Button id="yes">Yes</ToggleButtonGroup.Button>
        <ToggleButtonGroup.Button id="no">No</ToggleButtonGroup.Button>
      </ToggleButtonGroup>
      {answer === 'yes' && yesMessage && (
        <Alert className={styles.alert} variant="info">{yesMessage}</Alert>
      )}
      {answer === 'no' && noMessage && (
        <Alert className={styles.alert} variant="info">
          {noMessage}
        </Alert>
      )}
    </div>
  );
};

export default VisitorQuestion;
